import { setRecoil } from "recoil-nexus";
import { socket } from "../index";
import { kickState } from "../../atoms/roomDetail";

interface ListenReceiveIsKickPayload {
  roomId: string;
  statusCode: 'K' | 'F' | 'N';
}

const listenReceiveIsKick = () => {
  socket?.on('RECEIVE_IS_KICK', (payload: ListenReceiveIsKickPayload) => {
    if (payload.statusCode === 'K') {
      window.location.href = '/chatting-app/waiting-room?kick=1';
    }
    setRecoil(kickState, payload.statusCode);
  });
}

export default listenReceiveIsKick;